module.exports = __webpack_public_path__ + "static/media/top-slide-5.39745ec2.webp";